import { render, staticRenderFns } from "./form-gift-card.vue?vue&type=template&id=139aa4d4&scoped=true&"
import script from "./form-gift-card.vue?vue&type=script&lang=js&"
export * from "./form-gift-card.vue?vue&type=script&lang=js&"
import style0 from "./form-gift-card.vue?vue&type=style&index=0&id=139aa4d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139aa4d4",
  null
  
)

export default component.exports